import apiFetch from '../apiFetch'
export default function (token, header) {
  return apiFetch({ endPoint: `AuditAdmin/${header}/Documents`, method: 'GET', token: token })
}
